import { render, staticRenderFns } from "./bookmark-checkbox.vue?vue&type=template&id=00e05ae6&scoped=true&"
import script from "./bookmark-checkbox.vue?vue&type=script&lang=ts&"
export * from "./bookmark-checkbox.vue?vue&type=script&lang=ts&"
import style0 from "./bookmark-checkbox.vue?vue&type=style&index=0&id=00e05ae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e05ae6",
  null
  
)

export default component.exports